/**
 * @module i18n
 *
 * @link https://www.i18next.com
 */
import i18n from 'i18next';
import { initReactI18next, Trans, useTranslation } from 'react-i18next';
import translations from '~/config/translations';
import { enableI18nLog } from '~/config/settings/app.settings';

// This function handles explicitly initializing i18next. This should be called
// from the app's root index.js.
const init = ({ react = { useSuspense: true } } = {}) => {
  i18n.use(initReactI18next).init({
    lng: 'en-CA',
    fallbackLng: 'en-CA',
    ns: ['translations'],
    defaultNS: 'translations',
    returnEmptyString: false, // Use fallback translation if value on a key is empty
    debug: enableI18nLog,
    resources: {
      'en-CA': translations['en-ca'],
      'fr-CA': translations['fr-ca'],
      'es-ES': translations['es-es'],
    },
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (value, format, _lng) => {
        return format === 'uppercase' ? value.toUpperCase() : value;
      },
    },
    react,
  });
};

// Returns the language code with the country aspect in uppercase.
// e.g., 'en-ca' => 'en-CA'
const changeLanguage = (lang = 'en-ca') => {
  const [language, country] = lang.split('-');
  const i18nResource = `${language}-${country.toUpperCase()}`;

  return i18n.changeLanguage(i18nResource);
};

// This is just to ensure the `t()` function is using this singleton instance of i18n.
const t = (...args) => {
  // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
  return i18n.t(...args);
};

export { i18n, t, init, changeLanguage, Trans, useTranslation };
